import { Button } from "@kamae-apps/shared/Components/Atoms/Button/Button"
import { NewsBar } from "@kamae-apps/shared/Components/Molecules/NewsBar/NewsBar"
import { useIsPageScrolling } from "@kamae-apps/shared/Hooks/useIsPageScrolling"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { SidebarMode, useSidebarMode } from "../../Contexts/SidebarMode/SidebarModeContext"
import {
  CURRENT_SPECIAL_EVENT_SEASON,
  SpecialEventBannersBackground,
  SpecialEventTextColor,
  bannerBackgroundStyleVariants,
} from "../../Routes/Tatami/Containers/SpecialEventsTab/types"

export const NewsBarHandler: FC = () => {
  const { t } = useTranslation("app")
  const { isPageScrolling } = useIsPageScrolling()
  const { mode } = useSidebarMode()
  const navigate = useNavigate()
  const currentBackground = SpecialEventBannersBackground[CURRENT_SPECIAL_EVENT_SEASON]

  const isLight = bannerBackgroundStyleVariants[CURRENT_SPECIAL_EVENT_SEASON] === SpecialEventTextColor.LIGHT

  return (
    <div
      className={mode !== SidebarMode.MOBILE ? "mx-3 mt-3" : "mx-4 mt-3"}
      style={{
        transform: isPageScrolling ? "translateY(-100%)" : "translateY(0)",
        transition: "transform 0.3s ease-out",
        position: "relative",
      }}
    >
      <NewsBar
        title={t("app:newsBarModal.title")}
        primaryButton={
          <Button
            variant={isLight ? "button-secondary-glass-small" : "button-secondary-light-small"}
            onClick={() => navigate("/tatami#special-events")}
          >
            {t("app:newsBarModal.primaryButton")}
          </Button>
        }
        background={currentBackground}
        textColor={isLight ? "text-neutral-white" : "text-neutral-gray-600"}
        fullWidth
      />
    </div>
  )
}
